import _default from './Progress';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/modules/Progress/index.js
// module id = 687
// module chunks = 0